'use strict';

angular.module('mx.SolutionBuilderAgent').controller('mx.SolutionBuilderAgent.DesignWidgetController', [
	'mx.shell.ContextService',
	'mx.SolutionBuilderAgent.designerOpener',
	function designCtrl(contextService, designerOpener) {
		const vm = this;

		vm.execute = function (selectedObjects) {
			const item = selectedObjects[0];

			designerOpener.open(item._type, item._id);
		};
	},
]);
